import request from '@/utils/request'

export function selectClout(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/selectClout?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function addClout(data) {
    return request({
        url: `api/serviceCenter/material/addClout`,
        method: 'post',
        data,
    })
}

export function CloutToDownLoad(data) {
    return request({
        url: `api/serviceCenter/material/CloutToDownLoad`,
        method: 'post',
        data,
    })
}

export function selectMaterialType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/selectMaterialType`,
        method: 'post',
        data,
    })
}

export function cloutUpdateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/cloutUpdateComposition?`,
        method: 'post',
        data,
    })
}
export function cloutUnUpdateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/cloutUnUpdateComposition?`,
        method: 'post',
        data,
    })
}

export function cloutBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/material/cloutBatchDelete?`,
        method: 'post',
        data,
    })
}
